const baseUrl = "/insights-studio";

export default {
  baseUrl,
  INSIGHTS_PORTAL_CONFIGURATION: `${baseUrl}/insights/portal-configuration`,
  POPULATION_BUILDER: `${baseUrl}/analytic-tools/population-builder`,
  POPULATION_BUILDER_POPULATIONS: `${baseUrl}/analytic-tools/population-builder/populations`,
  COMMON_BLOCKS: `${baseUrl}/analytic-tools/population-builder/blocks`,
  ATTRIBUTE_BUILDER: `${baseUrl}/analytic-tools/attribute-builder`,
  ATTRIBUTE_BUILDER_GROUPS: `${baseUrl}/analytic-tools/attribute-builder/groups`,
  CONSUMER_REGISTRY: `${baseUrl}/registry-builder/registry`,
  DASHBOARD_MANAGER: `${baseUrl}/bi-workspace/dashboard-manager`,
  ANALYTICS_CONSOLE: `${baseUrl}/bi-workspace/analytics`,
  NOTEBOOKS_CONSOLE: `${baseUrl}/bi-workspace/notebooks`,
  DATA_CONSOLE: `${baseUrl}/bi-workspace/data`,
};
